module.exports = __webpack_public_path__ + "static/media/icon-cancel.a2082f06.svg";